import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { alpha } from '@mui/material/styles';
import { Box, List, ListItemText, Typography } from '@mui/material';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { hasPermission } from '../../protectedRoute';

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  // Solo se muestran los items que el usuario tiene permiso de ver
  const visibleGroups = data
    .map((group) => ({
      ...group,
      items: (group.items || []).filter((item) => !item.permission || hasPermission(item.permission)),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <Box {...other}>
      {visibleGroups.map((group) => (
        <Box key={group.subheader} sx={{ mb: 1 }}>
          <Typography
            variant="overline"
            sx={{
              px: 3,
              py: 1.5,
              display: 'block',
              color: alpha('#FFF', 0.35),
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '1px',
            }}
          >
            {group.subheader}
          </Typography>
          <List disablePadding sx={{ px: 2 }}>
            {group.items.map((item) => (
              <NavItem key={item.title} item={item} />
            ))}
          </List>
        </Box>
      ))}
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info } = item;

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        mb: 0.5,
        color: alpha('#FFF', 0.6),
        '&:hover': {
          bgcolor: alpha('#FFF', 0.08),
          color: '#FFF',
        },
        '&.active': {
          color: '#FFF',
          bgcolor: alpha('#d40100', 0.24),
          fontWeight: 'fontWeightBold',
          '& .nav-icon': {
            color: '#d40100',
          },
        },
      }}
    >
      <StyledNavItemIcon className="nav-icon">{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </StyledNavItem>
  );
}
